import React from 'react';

type DisableModuleProps = {
  name: string;
};

const DisabledModule: React.FC<DisableModuleProps> = (props: DisableModuleProps) => {
  const { name } = props;
  return (
    <div>
      <h2>Module {name} disabled</h2>
    </div>
  );
};

export default DisabledModule;
